import { render, staticRenderFns } from "./AddDelivery.vue?vue&type=template&id=be23daf6&"
import script from "./AddDelivery.vue?vue&type=script&lang=ts&"
export * from "./AddDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./AddDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports